export default __webpack_public_path__ + "static/media/yahoo.db999453.svg";